import { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export type LegacyCustomProps = {
  bold?: false
  justify?: false
  light?: false
  link?: false
  markdown?: false
  secondary?: false
  small?: false
  legacyTitle?: false
  underline?: false
  white?: false
}

const textSmallCss = ({ small }: LegacyCustomProps) =>
  small &&
  css`
    font-size: 14px;
  `

const textTitleCss = ({ legacyTitle }: LegacyCustomProps) =>
  legacyTitle &&
  css`
    font-size: 48px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 1.42;

    @media screen and (max-width: ${themeGet('breakpoints.0')}) {
      font-size: 24px;
      letter-spacing: 0.5px;
      line-height: 1.33;
    }
  `

const textLightCss = ({ light }: LegacyCustomProps) =>
  light &&
  css`
    font-weight: 300;
  `

const textBoldCss = ({ bold }: LegacyCustomProps) =>
  bold &&
  css`
    font-weight: 700;
  `

const textUnderlineCss = ({ underline }: LegacyCustomProps) =>
  underline &&
  css`
    text-decoration: underline;
  `

const textLinkCss = ({ link }: LegacyCustomProps) =>
  link &&
  css`
    cursor: pointer;
    user-select: none;
    color: ${themeGet('colors.font.link')};
  `

const textSecondaryCss = ({ secondary }: LegacyCustomProps) =>
  secondary &&
  css`
    color: ${themeGet('colors.font.secondary')};
  `

const textWhiteCss = ({ white }: LegacyCustomProps) =>
  white &&
  css`
    color: ${themeGet('colors.white')};
  `

const textJustifyCss = ({ justify }: LegacyCustomProps) =>
  justify &&
  css`
    text-align: justify;
  `

export {
  textBoldCss,
  textJustifyCss,
  textLightCss,
  textLinkCss,
  textSecondaryCss,
  textSmallCss,
  textTitleCss,
  textUnderlineCss,
  textWhiteCss,
}
